export const ACCOUNT_EVENTS = {
  PAGELOAD: 'account_page_loads',
  HELP_CENTER_CLICKED: 'help_support_click',
  CHAT_SUPPORT_CLICKED: 'hc_chat_now',
  PROFILE_CLICKED: 'profile_click',
};
